(function () {
  function exactVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.length === options.length && variant.options.every(function (value, index) {
        return value === options[index];
      });
    }) || null;
  }

  if (typeof module !== 'undefined') module.exports = { exactVariant: exactVariant };
  if (typeof window === 'undefined' || window.__h1ExactVariants) return;
  window.__h1ExactVariants = true;

  function sync(picker, selected) {
    if (!picker) return;
    var variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
    var fields = Array.from(picker.querySelectorAll('fieldset'));
    var options = fields.map(function (field) { return field.querySelector('input:checked')?.value; });
    var variant = selected || exactVariant(variants, options);
    var soldOut = window.theme.variantStrings.soldOut;
    fields.forEach(function (field, index) {
      field.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var candidateOptions = options.slice();
        candidateOptions[index] = input.value;
        var candidate = exactVariant(variants, candidateOptions);
        var unavailable = !candidate?.available;
        input.classList.toggle('disabled', unavailable);
        input.dataset.h1Available = String(!unavailable);
        document.querySelectorAll('label[for="' + CSS.escape(input.id) + '"]').forEach(function (label) {
          label.classList.toggle('is-unavailable', unavailable);
          label.title = input.value + (unavailable ? ' — ' + soldOut : '');
          var stockLabel = label.querySelector('[data-h1-stock-label]');
          if (stockLabel) stockLabel.hidden = !unavailable;
        });
      });
    });
    var section = picker.closest('[id^="shopify-section-"]');
    var sticky = document.querySelector('product-sticky-form[data-section-id="' + section.id.replace('shopify-section-', '') + '"]');
    sticky?.querySelectorAll('[data-sticky-color-toggle], [data-sticky-size-toggle], [data-sticky-size-select] option').forEach(function (control) {
      var index = Number(control.dataset.optionIndex ?? control.parentElement.dataset.optionIndex);
      var value = control.dataset.value || control.value;
      var radio = fields[index]?.querySelector('input[data-option-value="' + CSS.escape(value) + '"]');
      var unavailable = !radio || radio.dataset.h1Available !== 'true';
      control.disabled = false;
      control.classList.toggle('is-unavailable', unavailable);
      control.dataset.h1Available = String(!unavailable);
      control.setAttribute('aria-label', value + (unavailable ? ' — ' + soldOut : ''));
      control.title = value + (unavailable ? ' — ' + soldOut : '');
      if (control.hasAttribute('data-sticky-color-toggle')) control.setAttribute('aria-current', String(radio?.checked || false));
      if (control.hasAttribute('data-sticky-size-toggle')) control.setAttribute('aria-pressed', String(radio?.checked || false));
    });
    var productInfo = picker.closest('product-info');
    productInfo?.productForm?.toggleSubmitButton(!variant?.available, variant ? soldOut : window.theme.variantStrings.unavailable, !variant);
    productInfo?.productStickyForm?.toggleSubmitButton(!variant?.available, variant ? soldOut : window.theme.variantStrings.unavailable, !variant);
  }

  function init() {
    document.querySelectorAll('variant-picker[data-exact-variants]').forEach(function (picker) {
      sync(picker, JSON.parse(picker.querySelector('[data-selected-variant]').textContent));
      if (picker.hasAttribute('data-stock-fixture')) {
        var notice = document.createElement('p');
        notice.textContent = 'Staging stock fixture — inventory unchanged; cart submission blocked.';
        notice.setAttribute('data-h1-fixture-notice', '');
        picker.before(notice);
      }
    });
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event.data;
      var picker = document.getElementById('VariantPicker-' + data.sectionId + '-' + data.productId);
      if (picker?.hasAttribute('data-exact-variants')) sync(picker, data.variant);
    });
    document.addEventListener('submit', function (event) {
      if (document.querySelector('variant-picker[data-stock-fixture]') && event.target.action?.includes('/cart/add')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
